import Phaser from 'phaser';
import { gameEvents } from '../core/events';

export interface BossBarConfig {
  x: number;
  y: number;
  width: number;
  name: string;
  hp: number;
}

/**
 * Barra de vida gigante del jefe, montada dentro de la franja de combate
 * mientras dura la oleada de jefe. Al crearse emite `combat:bossSpawned`
 * para que el resto del juego (HUD superior, fuera de este módulo) pueda
 * espejar el nombre/vida si quiere mostrarlo también ahí.
 */
export class BossController {
  private readonly view: Phaser.GameObjects.Container;
  private readonly fill: Phaser.GameObjects.Rectangle;
  private readonly barWidth: number;
  private readonly maxHp: number;

  constructor(
    scene: Phaser.Scene,
    parent: Phaser.GameObjects.Container,
    config: BossBarConfig
  ) {
    this.barWidth = config.width;
    this.maxHp = Math.max(1, config.hp);

    this.view = scene.add.container(config.x, config.y);
    const bg = scene.add
      .rectangle(0, 0, config.width, 14, 0x1b1030)
      .setOrigin(0, 0.5)
      .setStrokeStyle(1, 0x453a70);
    this.fill = scene.add.rectangle(1, 0, config.width - 2, 12, 0xe0524d).setOrigin(0, 0.5);
    const label = scene.add
      .text(config.width / 2, -12, config.name, {
        fontFamily: 'monospace',
        fontSize: '11px',
        color: '#f4f0ff',
      })
      .setOrigin(0.5, 1);
    this.view.add([bg, this.fill, label]);
    parent.add(this.view);

    gameEvents.emit('combat:bossSpawned', { name: config.name, hp: config.hp });
  }

  setHp(hp: number): void {
    const pct = Phaser.Math.Clamp(hp / this.maxHp, 0, 1);
    this.fill.width = (this.barWidth - 2) * pct;
  }

  destroy(): void {
    this.view.destroy();
  }
}
